import Page from "../../../layout/Page";
import PageContent from "../../../layout/PageContent";
import PageHeader from "../../../layout/PageHeader";
import * as React from "react";
import {ListTradeInsList} from "../../lists/ListTradeInsList";
import {ViewFilter} from "../../../components/ViewFilter";

export const LogisticsTradeInsListPage = () => {
   return <Page>
      <PageHeader title="TradeIns"/>
      <PageContent>
         <ViewFilter dataType="tradeins">
            {(viewId) => (
               <ListTradeInsList 
                  globalId={"logisticsTradeIns"} 
                  extrafilter={{
                     _operators: {
                        brandHouseId: {
                           ne: '601c19a2c6dac20032263343'
                        }
                     }
                  }}
                  viewId={viewId}
               />
            )}
         </ViewFilter>
      </PageContent>
   </Page>
}

